import { Component, Input, EventEmitter, Output, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbActions } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import { UEData } from '../../providers/ue-data';

import { CameraPreview, CameraPreviewPictureOptions, CameraPreviewOptions, CameraPreviewDimensions } from '@ionic-native/camera-preview';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { ImageCroppedEvent, ImageCropperComponent, CropperPosition } from 'ngx-image-cropper';

import { Http } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { KontrollenData } from '../../pages/kontrollen/kontrollen-data';

import { LicenseplateProviderNew } from '../../providers/licenseplate/licenseplate_new';
import moment from 'moment';

import { Vibration } from '@ionic-native/vibration';
declare var window: any;

@Component({
  selector: 'lppbrecognizer',
  templateUrl: 'lppbrecognizer.html'
})
export class LPPBRecognizerComponent {
  @Output() onPlate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFalschparkerErfassen: EventEmitter<any> = new EventEmitter<any>();

  private _showPlateImage;
  @Input('showPlateImage') 
  get showPlateImage(): number {
    return this._showPlateImage;
  }
  set showPlateImage(value: number) {
    this._showPlateImage = value;    
  }  

  private _showFalschparkerButton;
  @Input('showFalschparkerButton') 
  set showFalschparkerButton(value: number) {
    this._showFalschparkerButton = value;    
  }    

  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;  
  @ViewChild('wrapperContainer') wrapperContainer: ElementRef;
  private data;
  autonummer = "";
  croppedImage: any = '';   
  bCropper = false;
  private wrapperWidth: number;
  plateTimeout;

  constructor(
    public userData: UserData
    , public pbData: ParkbewilligungenData
    , private lpProviderNew: LicenseplateProviderNew
    , public zone: NgZone
    , public common: CommonData
    , public http: Http
    , public cameraPreview: CameraPreview
    , private base64ToGallery: Base64ToGallery
    , public ueData: UEData
    , private vibration: Vibration
    , private kontrollenData: KontrollenData
  ) 
  {
      this.data = [];
      this.wrapperWidth = 100;

  }

  public stopCamera(){    
    this.cameraPreview.stopCamera();
   }
   



  loadData(){

  }
  public falschparkerErfassen(){
    if(this.onFalschparkerErfassen){
      this.onFalschparkerErfassen.emit({ event:event, plate: this.autonummer });
    }
  }


  public startCamera(){
    this.wrapperWidth = this.wrapperContainer.nativeElement.offsetWidth;
    const cameraPreviewOpts: CameraPreviewOptions = {
      x: window.screen.width-this.wrapperWidth-33,
      y: 145,
      width: this.wrapperWidth,
      height: 130,
      camera: 'rear',
      tapPhoto: false,
      previewDrag: true,
      toBack: false,
      alpha: 1
      //storeToFile: false
    };
    
    // start camera
    this.cameraPreview.startCamera(cameraPreviewOpts).then(
      (res) => {
        //console.log(res)
        //this.camerastarted = true;
      },
      (err) => {
        console.log(err)
      });
      
      this.cameraPreview.show();
   }  

   plateChanged(event, forcelookup = false){
    //console.log("Plate changed:"); 
    //console.log(this.autonummer);

    clearTimeout(this.plateTimeout);
    //-- Bei forcelookup direkt abfragen ----
    if(forcelookup){
      if(this.onPlate){
        this.onPlate.emit({ event:event, plate: this.autonummer });
      }

    }
    else{
      this.plateTimeout = setTimeout(() => {  
        //this.searchQuery = ev.target.value;
        if(this.onPlate){
          this.onPlate.emit({ event:event, plate: this.autonummer });
        }
      }, 800);  
  
    }



    
   }


   onTakePicture(){
    
    const pictureOpts: CameraPreviewPictureOptions = {
      width: 1024,
      height: 1024,
      quality: 40
    }  
    
    this.cameraPreview.takePicture(pictureOpts).then(async (imageData) => {
      this.vibration.vibrate(100);  
      this.autonummer = "";
      this.bCropper = true;
      //this.imageCropper.imageBase64 = imageData;
      this.kontrollenData.lppicture = 'data:image/jpeg;base64,' + imageData;
     
      //this.picture = 'data:image/jpeg;base64,' + imageData;
      this.lpProviderNew.remoteFindLicenseplate(imageData).then(async (data) => {
        this.autonummer = String(data["plate"]);
        this.plateChanged(null, true);
        if(this._showPlateImage){
          let cp = {} as CropperPosition;
          let scale = (window.screen.width)/1024;
          scale = 0.465;
          
          let xpadding = ((data["box"].xmax-data["box"].xmin)*.1);
          let ypadding = ((data["box"].ymax-data["box"].ymin)*.1);
          cp.x1 = (data["box"].xmin * scale)-xpadding;
          cp.y1 = (data["box"].ymin * scale)-ypadding;
          cp.x2 = (data["box"].xmax * scale)+xpadding;
          cp.y2 = (data["box"].ymax * scale)+ypadding;
  
          this.bCropper = false;
          this.imageCropper.cropper = cp;
          
          let image = await this.imageCropper.crop();
          //console.log(image);
          this.imageCropper.disabled = true;
          this.croppedImage = image.base64;  
        }

      });

      
    }, (err) => {
      console.log(err);
      //this.picture = 'assets/img/test.jpg';
    });  
    
   }   
  
}



// WEBPACK FOOTER //
// ./src/components/lppbrecognizer/lppbrecognizer.ts